import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { MdArrowForwardIos } from "react-icons/md";

import CustomCalendar from "../../../common/CustomCalendar";

import { SetModalProperties } from "../../../redux/v2/utils/actions";
import { delay, parseJSON } from "../../../utils";

function HomeCalendar(props) {
    const { workoutPlan, calendar, isDesktop } = props;
    const { account } = props.User;
    const [reposition, setReposition] = useState(false);
    const [fixPosition, setFixPosition] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [pointDate, setPointDate] = useState(null);
    const onboardingDetail = account?.onboardingDetails?.[account?.onboardingDetails?.length - 1];

    useEffect(() => {
        delay(() => {
            if (!isDesktop) {
                setReposition(false);
                setFixPosition(false);
            }
        }, 200);
    }, [selectedDate]);

    useEffect(() => {
        if (onboardingDetail?.created_at) {
            setPointDate(onboardingDetail?.created_at);
        }
    }, [onboardingDetail?.created_at]);

    return (
        <div id="home-calendar-wrapper" className={`${reposition ? "hcw-reposition" : ""} ${fixPosition ? "fixed-position" : ""}`}>
            <div>
                <CustomCalendar
                    style={{ height: reposition ? "450px" : "105px" }}
                    showHeader={reposition}
                    onboarding={isDesktop}
                    highlights={{
                        type: "week",
                        values: calendar?.highlights ? calendar?.highlights : {}
                    }}
                    plots={workoutPlan ? workoutPlan?.plots : {}}
                    calendarDates={calendar}
                    tags={{ 5: "circle-question" }}
                    onChange={(data) => {
                        setSelectedDate(data);
                        props?.setSelectedDate(data);
                    }}
                    pointDate={pointDate}
                />
                <div id="home-calendar-footer">
                    {!isDesktop ? < div id="hcf-arrow-down" className="flex-c">
                        <MdArrowForwardIos onClick={() => {

                            setReposition(!reposition);
                            setFixPosition(!fixPosition);

                            // if (reposition) {
                            //     delay(() => {
                            //         setFixPosition(!fixPosition);
                            //     }, 400)
                            // } else {
                            //     setFixPosition(!fixPosition);
                            // }

                            // props.SetModalProperties({
                            //     id: "home-page-calendar",
                            //     height: "550px",
                            //     isShow: true,
                            //     title: "",
                            //     body: <CustomCalendar
                            //         highlights={{
                            //             type: "week",
                            //             values: {
                            //                 1: {
                            //                     border: "4px solid #8B1E3F",
                            //                 },
                            //                 3: {
                            //                     border: "4px solid #6BA292",
                            //                 },
                            //                 5: {
                            //                     border: "4px solid #8B1E3F",
                            //                 },
                            //             }
                            //         }}

                            //         tags={{ 24: "solid-orange-circle", 5: "circle-question" }}
                            //     />,
                            //     actions: [],
                            //     top: true,
                            //     showCloseButton: false,
                            // });
                        }} />
                    </div> : ""}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    SetModalProperties,
})(HomeCalendar);